module.exports = __webpack_public_path__ + "images/emoji/zzz.552763212fb5cd927564.png";